import { z } from 'zod';
import { id } from '../atomic/id';

export const accessSchema = z.object({
  services: z.array(id),
  role: z.string(),
});
